var map = {
	"./about-us.svg": 758,
	"./betting-icon.svg": 759,
	"./bonus.svg": 760,
	"./coin.svg": 761,
	"./contact-us.svg": 762,
	"./download-app.svg": 763,
	"./edit-btn.svg": 764,
	"./feedback.svg": 765,
	"./global.svg": 766,
	"./info-centre.svg": 767,
	"./instant-rebate.svg": 768,
	"./mall-icon.svg": 769,
	"./message.svg": 770,
	"./personal-info-edit.svg": 771,
	"./r77-coin.svg": 772,
	"./r77-rewards.svg": 773,
	"./redemption-icon.svg": 774,
	"./referral.svg": 775,
	"./resp-gaming.svg": 776,
	"./security.svg": 777,
	"./transaction-icon.svg": 778,
	"./vip-icon.svg": 779,
	"./wallet-icon.svg": 780
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 209;